// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"j2-z","colorTextValue":"k2-z","swatches":"l2-z","collapseLink":"m2-z","isCollapsed":"n2-z","dropdown":"o2-z","disabled":"p2-z"};